export const SERVICE_UPDATES = {
    EVENTS_ERROR: 'events-error',
    EVENTS_UPDATED: 'events-updated'
};
